var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 77,
    viewBox: "0 10 70 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2136 5.29338L62.5618 53.5882C63.4355 55.2528 62.2282 57.25 60.3482 57.25H9.65182C7.77179 57.25 6.56448 55.2528 7.4382 53.5882L32.7864 5.29338C33.7228 3.50918 36.2772 3.50918 37.2136 5.29338Z",
    fill: "#E83131",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1207 18.7699C32.0554 17.8125 32.8144 17 33.774 17H36.226C37.1856 17 37.9446 17.8125 37.8793 18.7699L36.602 37.5035C36.5446 38.346 35.8444 39 35 39V39C34.1556 39 33.4554 38.346 33.398 37.5035L32.1207 18.7699Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45.6571C32 44.7419 32.7419 44 33.6571 44H36.3429C37.2581 44 38 44.7419 38 45.6571V48.3429C38 49.2581 37.2581 50 36.3429 50H33.6571C32.7419 50 32 49.2581 32 48.3429V45.6571Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b002ff5a.svg";
export { ForwardRef as ReactComponent };